import { render, staticRenderFns } from "./modalEditarPlano.vue?vue&type=template&id=2d5e6b88"
import script from "./modalEditarPlano.vue?vue&type=script&lang=js"
export * from "./modalEditarPlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports